<template>
  <v-dialog v-model="modal.visible" max-width="400">
    <v-card>
      <v-card-title class="headline">{{ modal.title }}</v-card-title>

      <v-card-text>{{ modal.text }}</v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="modal.color + ' darken-1'" text @click="modal.visible = false">Fermer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LayoutModal',
  data () {
    return {
      modal: {
        visible: false,
        title: '',
        color: '',
        text: ''
      },
    }
  },
  methods: {
    onEvent ({ type, text, modal }) {
      if (modal) {
        this.modal.visible = true
        this.modal.text = text
        this.modal.color = type

        if (type === 'info') this.modal.title = 'Information'
        else if (type === 'success') this.modal.title = 'Succès'
        else if (type === 'warning') this.modal.title = 'Attention'
        else if (type === 'error') this.modal.title = 'Erreur'
      }
    }
  },
  mounted () {
    this.$bus.on('ui/message', this.onEvent)
  },
  destroyed() {
    this.$bus.off('ui/message', this.onEvent)
  }
}
</script>

<style scoped>

</style>